module.exports = __webpack_public_path__ + "media/images/flags/gi-345b700f04babfed53e1b6286d2ad511.svg";